import { createContext } from "react"

export const UserContext = createContext<any>(null)
export const UpdateUserContext = createContext<any>(null)

export const VibratoClientContext = createContext<any>(null)
export const NotificationsContext = createContext<any>(null)
export const PushTokenContext = createContext<any>(null)

export const CampaignContext = createContext<any>(null)

export const UpgradeModalContext = createContext<any>(null)

export const IntroModalContext = createContext<any>(null)

export const AlertContext = createContext<any | null>(null)

interface InAppPurchasesContextType {
  store?: CdvPurchase.Store
  plusProduct?: any
  purchasePlus?: () => void
  loading?: boolean
  processingTransaction?: boolean
  transactionError?: string
}

export const AppleInAppPurchasesContext = createContext<InAppPurchasesContextType | undefined>(undefined)
